export default function onPointerMove(callback) {
  this.input.addMoveCallback(() => callback());
}
